import { useState } from 'react';

import _ from 'lodash';

import { SearchLightIcon } from '@/src/Views/Shared/Icons';

type FilterType = {
	terms: Record<string, any>;
	searchLabel: string;
	selectLabel: string;
	noResultLabel: string;
	setValue: (e: string) => void;
	value: string;
	selectClass?: string;
	actifClass?: string;
};

export default function Filter(props: FilterType) {
	const {
		terms,
		searchLabel,
		selectLabel,
		noResultLabel,
		setValue,
		value,
		selectClass = '',
	} = props;
	const [open, setOpen] = useState(false);
	const [query, setQuery] = useState<string | null>(null);

	const options = _.map(_.entries(terms), ([k, v]) => ({ label: v, value: k }));

	const filter = (options: { value: string; label: string }[]) => {
		return query
			? options.filter((option) => option.label.toLowerCase().indexOf(query.toLowerCase()) > -1)
			: options;
	};

	return (
		<div className={`${selectClass} relative px-4 py-3 tablet:min-w-[200px]`}>
			<button
				role='combobox'
				id='combo-list1'
				aria-controls='combo-list1-content'
				aria-expanded={open}
				onClick={() => setOpen(!open)}
				aria-label={value ? options.find((term) => term.value === value)?.label : selectLabel}
				className='flex w-full items-center justify-between gap-3'
			>
				{value ? options.find((term) => term.value === value)?.label : selectLabel}
				<svg
					width='14'
					height='9'
					viewBox='0 0 14 9'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					aria-hidden='true'
					className={`transition-all ${open ? 'rotate-180' : 'rotate-0'}`}
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.00005 8.91421L0.292941 2.20711L1.70715 0.792894L7.00005 6.08579L12.2929 0.792895L13.7072 2.20711L7.00005 8.91421Z'
						fill='currentColor'
					/>
				</svg>
			</button>
			{open && (
				<div
					className={`${selectClass} absolute left-0 z-20 mt-6 max-h-[400px] w-full overflow-y-auto px-4 py-3 tablet:min-w-[200px]`}
				>
					{options.length > 0 ? (
						<>
							<div className='flex items-center gap-1'>
								<SearchLightIcon />{' '}
								<input
									className='w-full border-none p-1'
									type='text'
									onChange={(e) => setQuery(e.target.value)}
									placeholder={searchLabel}
								/>
							</div>

							<div className='mt-5'>
								{filter(options).length > 0 ? (
									<ul className='flex flex-col gap-2'>
										{filter(options).map((term) => (
											<li key={term.value} className='text-center'>
												<button
													className='hover:opacity-60'
													onClick={() => {
														setValue(term.value);
														setOpen(!open);
													}}
												>
													{term.label}
												</button>
											</li>
										))}
									</ul>
								) : (
									<>{noResultLabel}</>
								)}
							</div>
						</>
					) : (
						<>{noResultLabel}</>
					)}
				</div>
			)}
		</div>
	);
}
